module.exports = __webpack_public_path__ + "img/8.7b21e423.png";